import { Props_SnippetSpacer } from './Spacer.props'

const SnippetSpacer = (props: Props_SnippetSpacer) => (
    <div
        className='snippet-spacer'
        style={{
            height: props.snippet.height.value,
            backgroundColor: props.snippet?.backgroundColor?.value ?? 'transparent',
        }}
    ></div>
)

export default SnippetSpacer